export default __webpack_public_path__ + "static/media/1198.7b12ece6.png";